import { useRef, type KeyboardEvent as ReactKeyboardEvent } from 'react';
import { useIntl } from 'react-intl';

import { ChevronLeftDoubleIcon } from '@dynatrace/strato-icons';

import { Control } from './components/Control.js';
import { TOOLBAR_MESSAGES } from './messages.js';
import { useA11yToolbarTabIndex } from '../../hooks/useA11yToolbarTabIndex.js';

interface CollapseButtonProps {
  onClick: (isExpanded: boolean) => void;
}

export const CollapseButton = ({ onClick }: CollapseButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const intl = useIntl();
  const tabIndex = useA11yToolbarTabIndex('collapse');

  const onClickHandler = () => {
    onClick(false);
  };

  const onKeyDownHandler = (event: ReactKeyboardEvent) => {
    if (event.key === 'Enter') {
      onClick(false);
    }
  };

  return (
    <Control
      ref={buttonRef}
      testId="toolbar-collapse-button"
      prefixIcon={<ChevronLeftDoubleIcon />}
      tooltipText={intl.formatMessage(TOOLBAR_MESSAGES.chartToolbarCollapse)}
      onKeyDown={onKeyDownHandler}
      onClick={onClickHandler}
      tabIndex={tabIndex}
      divider="left"
      data-dt-name="ToolbarCollapse"
    />
  );
};

CollapseButton['displayName'] = 'CollapseButton';
